module.exports = __webpack_public_path__ + "img/undo.bcfc2028.svg";